<template>
  <div ref="tabsRoot" class="space-y-6">
    <UTabs v-model="activeTab" variant="link" size="xl" :items="tabs" class="w-full" :ui="{
      label: 'uppercase px-4',
      content: 'p-2 md:p-4 pt-6'
    }">
      <template #description>
        <div id="description" class="prose max-w-none space-y-4">
          <p class="text-gray-700 leading-relaxed">
            {{ product.description }}
          </p>
          <!-- <h3 class="text-lg font-semibold text-gray-900 mt-6 mb-3">Product Details</h3>
          <ul class="space-y-2 text-gray-700">
            <li v-for="(detail, index) in productDetails" :key="index" class="flex items-start gap-2">
              <Icon name="i-heroicons-check" class="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span>{{ detail }}</span>
            </li>
          </ul> -->
        </div>
      </template>

      <template #reviews>
        <ProductReviews 
          :rating="product.rating"
          :productId="product.id"
          class="max-w-4xl"
        />
      </template>
    </UTabs>
  </div>
</template>

<script setup lang="ts">
const { t: $t } = useI18n()

import ProductReviews from './ProductReviews.vue';
import type { TabsItem } from '@nuxt/ui'
import type { Product } from '~/types';

defineProps<{
  product: Product
}>()

const tabs: TabsItem[] = [
  { label: $t('Description'), value: 'description', slot: 'description' },
  { label: $t('Reviews'), value: 'reviews', slot: 'reviews' }
]

const route = useRoute()
const router = useRouter()

const activeTab = computed({
  get() {
    const tab = route.hash.replace('#', '') || 'description'

    return tab
  },
  set(tab) {
    router.push({
      hash: '#' + tab
    })
  }
})

const tabsRoot = ref<HTMLElement | null>(null)

watch(activeTab, (newTab) => {
  if (tabsRoot.value) {
    const offset = tabsRoot.value.getBoundingClientRect().top + window.scrollY - 110
    window.scrollTo({ top: offset, behavior: 'smooth' })
  }
})

watch(route, (newRoute) => {
  const tab = newRoute.hash.replace('#', '')

  if (tab && tabs.find(t => t.value === tab)) {
    activeTab.value = tab
  }
}, { immediate: true })
</script>